import { IDemandProposalViewModal } from 'viewModels';
import {
  AttachmentType,
  AudienceType,
  CorrespondenceType,
  HistoryType,
  RequestsSubmittedStatus,
  ServiceStatus,
  UserProfileType,
} from '../../../types/enums';

export const demandProposalMock: IDemandProposalViewModal = {
  id: 'demand-001',
  userId: 'user-123',
  user: {
    id: 'user-123',
    firstName: 'João',
    lastName: 'Silva',
    profilePictureId: 'pic-456',
  },
  solicitationId: 'sol-789',
  court: {
    id: 'court-001',
    name: 'Tribunal de Justiça',
    districtId: 'district-001',
  },
  createdById: 'user-123',
  specialty: {
    id: 'spec-001',
    name: 'Direito Civil',
    disabled: false,
    createdById: 'user-123',
  },
  correspondence: {
    id: 'corr-001',
    name: 'Correspondência Exemplo',
    type: CorrespondenceType.AUDIENCE,
    profileTypes: [UserProfileType.LAWYER],
    attachmentTypes: [AttachmentType.OTHER],
    disabled: false,
    userId: 'user-123',
  },
  note: 'Descrição exemplo',
  protocolNumber: 'PROTO-001',
  dateLimit: new Date('2025-12-31'),
  address: {
    uf: 'SP',
    ufCode: 35,
    city: 'São Paulo',
    cityCode: 3550308,
    street: 'Rua Exemplo',
    complement: 'Apto 101',
    postalCode: '01000-000',
    number: 100,
    latitude: -23.55052,
    longitude: -46.633308,
  },
  value: 1000,
  status: ServiceStatus.IN_APPROVAL_REQUESTER,
  createdAt: new Date(),
  history: [
    {
      id: 'hist-001',
      solicitationId: 'sol-789',
      createdAt: new Date(),
      newSolicitationDateLimit: new Date('2025-11-30'),
      prevSolicitationDateLimit: new Date('2025-10-31'),
      newSolicitationValue: 1200,
      prevSolicitationValue: 1000,
      createdBy: 'user-123',
      text: 'Histórico de alteração de valor e prazo.',
      visible: true,
      type: HistoryType.ACCEPT_ADDITIONAL_VALUE,
      attachments: [],
    },
  ],
  partsNames: [
    {
      id: 'part-001',
      name: 'Parte Requerente',
      solicitationId: 'sol-789',
    },
  ],
  requestSubmitted: {
    id: 'req-001',
    userId: 'user-123',
    solicitationId: 'sol-789',
    user: {
      id: 'corr-user-001',
      firstName: 'Maria',
      lastName: 'Souza',
      profilePictureId: 'pic-789',
      url: 'http://example.com/profile',
      isVerified: true,
      presentation: 'Advogada especialista em Direito Civil.',
      address: {
        uf: 'SP',
        ufCode: 35,
        city: 'São Paulo',
        cityCode: 3550308,
        street: 'Rua Exemplo',
        complement: 'Apto 101',
        postalCode: '01000-000',
        latitude: -23.55052,
        longitude: -46.633308,
      },
    },
    status: RequestsSubmittedStatus.PENDING,
    refusalReason: undefined,
    justificationRefusal: '',
    justificationCounterProposal: 'Contra proposta de 1100',
    counterProposal: 1100,
  },
  processNumber: 'PROC-001',
  folderNumber: 'FOLDER-001',
  audienceType: AudienceType.INITIAL,
  districtName: 'Distrito Central',
  districtUfCode: 35,
  client: {
    id: 'client-001',
    name: 'Cliente Exemplo',
  },
  audienceLink: 'http://example.com/audience',
  isLawyer: true,
  isRepresentative: false,
  isVirtualAudience: true,
  attachments: [],
};
